import {
    Container,
    CssBaseline,
    Link,
    Typography,
    Paper,
    Box
} from "@mui/material";
import { Notification } from "react-admin";
import { LoginForm } from "./Login.form";
import { getCredentials } from "../../config/auth";
import { shouldShowCredentials } from "../../config/environment";

const Copyright = (props) => (
    <Typography variant='body2' color='text.secondary'
        align='center' {...props}>
        {'Copyright © '}
        <Link color='inherit' href='https://schoolstart.ca'>
            School Start
        </Link>{' '}
        {new Date().getFullYear()}
    </Typography>
)

export const LoginPage = () => (
    <Container component='main' maxWidth='xs'>
        <CssBaseline />

        <LoginForm />

        {/* Credentials info - show based on environment and settings */}
        {shouldShowCredentials() && (
            <Paper sx={{ mt: 2, p: 2, bgcolor: 'grey.100' }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    <strong>Available Credentials:</strong>
                </Typography>
                <Box component="ul" sx={{ mt: 1, mb: 0, pl: 2 }}>
                    <Typography component="li" variant="body2" color="text.secondary">
                        {getCredentials().username} / {getCredentials().password}
                    </Typography>
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    Using environment credentials
                </Typography>
            </Paper>
        )}

        <Copyright sx={{ mt: 8, mb: 4 }} />
        <Notification />
    </Container>
)